export default "__VITE_ASSET__b5f152e5__"